import { useEffect, useRef } from 'react';

// TEMP DIAGNOSTIC (workflow-assistant first-message-loss investigation):
// Logs a unique instance id on mount/unmount so a genuine React remount is
// unambiguous in the browser console -- a re-render keeps the same instance id,
// a remount produces a brand-new one. Remove once root-caused.
export function useMountLogger(label: string, extra?: () => Record<string, unknown>): string {
  const instanceId = useRef<string | undefined>(undefined);
  if (!instanceId.current) {
    instanceId.current = Math.random().toString(36).slice(2, 8);
  }

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(`[DIAG][MOUNT] ${label} instance=${instanceId.current}`, {
      timestamp: new Date().toISOString(),
      ...(extra ? extra() : {}),
    });
    return () => {
      // eslint-disable-next-line no-console
      console.log(`[DIAG][UNMOUNT] ${label} instance=${instanceId.current}`, {
        timestamp: new Date().toISOString(),
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return instanceId.current;
}
